export const LOAD_REFERENTIALS = 'assets/LOAD_REFERENTIALS';
export const RECEIVE_REFERENTIALS = 'assets/RECEIVE_REFERENTIALS';
